module.exports = __webpack_public_path__ + "static/media/Instagram.afac8448.png";